import { defineStore } from 'pinia'
import type { RouteRecordRaw } from 'vue-router'
import type { SiteConfig } from '/@/stores/interface'

export const useSiteConfig = defineStore('siteConfig', {
    state: (): SiteConfig => {
        return {
            siteName: '',
            recordNumber: '',
            version: '',
            cdnUrl: '',
            apiUrl: '',
            upload: {
                mode: 'local',
            },
            headNav: [],
            initialize: false,
            userInitialize: false,
            user_register_verify: '',
            payment_agreement: '',
            data_agreement: '',
            user_login_phone: 0,
            user_login_wechat: 0,
            logo: '',
            new_version: '',
            enterpriseHint: '',
            tenderHint: '',
            dataHint: '',
            bidHint: '',
            logo_short: '',
            logo_long: '',
            bottom_logo: '',
            bottom_images: '',
            customer_service_url: '',
            copyright: '',
            data_url: [],
            nav_url: '',
            bottom_ewm: '',
            analyzeTenderScore: '',
            imageV1Score: '',
            imageV2Score: '',
            ganntImageScore: '',
            videoV2Score: '',
            videoV1Score: '',
            paymentHint1: '',
            paymentHint2: '',
            aiImageScore: '',
            hotline: '',
            w_id: '',
            years: 0,
            domain: 0,
            training_data: 0,
            generate: 0,
            free_word_logo: '',
            pay_activity_logo: ''
        }
    },
    actions: {
        dataFill(state: SiteConfig) {
            this.$state = state
        },
        setHeadNav(headNav: RouteRecordRaw[]) {
            this.headNav = headNav
        },
        setInitialize(initialize: boolean) {
            this.initialize = initialize
        },
        setUserInitialize(userInitialize: boolean) {
            this.userInitialize = userInitialize
        },
    },
})
